<template>
  <div class>
<!--     <van-cell
      title-style="vertical-align: sub;font-size: 14px;color:rgba(53,53,53,1);font-weight:500;"
      title="账户管理"
      :icon="require('@/images/sz.png')"
      is-link
      to="account"
    /> -->

      <div class="account-item" @click="toAccount">
        <div class="item-icon">
          <img src="@/images/sz.png" alt />
        </div>
        <div class="item-content sign">
          <div>
            <div class="title">账户管理</div>
          </div>
        </div>
        <div class="item-arrow">
          <i class="cubeic-arrow"></i>
        </div>
      </div>

      <!-- 电子签名开始 -->
      <div class="account-item" @click="toAutograph">
        <div class="item-icon">
          <img src="@/images/icon-sign.png" alt />
        </div>
        <div class="item-content sign" style="display:flex; justify-content: space-between; padding-right: 0.625rem;">
          <div>
            <div class="title">电子签名</div>
            <!-- <div class="hint">填写本人签名</div> -->
          </div>
          <div v-if="imgData" class="resign">
            <img :src="imgData" alt="" style="height:30px;" />
            <div
              style="margin: 0 0 0 1.5rem; color: #2cc7c5; font-size: 14px;"
            >
              重新签名
            </div>
          </div>
        </div>
        <div v-if="!imgData" class="item-arrow">
          <i class="cubeic-arrow"></i>
        </div>
      </div>
      <!-- 电子签名结束 -->

    <!-- 签名开始 -->
    <div
      v-show="test"
      class="sign"
      style="position: fixed; top: 0; z-index: 9999; bottom: 0"
    >
      <signature @closePop="test=false" @saveImg="complete"></signature>
    </div>
    <!-- 签名结束 -->

  </div>
</template>
<script type="text/ecmascript-6">
import signature from "../../../components/signature.vue";
import {
  addSignature,
  getSignature,
} from "@/common/api";
export default {
  props: {},
  components: {
    signature,
  },
  data() {
    return {
      imgData: "",
      test: false,
      loginInfo: {}
    };
  },
  created() {
    this.loginInfo = JSON.parse(window.localStorage.getItem("loginInfo"));
    this.getSignature();
  },
  methods: {
    toAutograph(){
      this.test = true;
    },
    //获取电子签名
    getSignature() {
      getSignature({ staffId: this.loginInfo.id }).then((res) => {
        if (res.code == 200) {
          this.imgData = res.data.hosProposalSign;
        } else {
          this.imgData = "";
        }
      });
    },
    //电子签名确定
    complete(data) {
      if (data) {
        this.imgData = data;
        var data = {
          staffId: this.loginInfo.id,
          hosProposalSign: this.imgData,
        };
        addSignature(data).then((res) => {
          if (res.code == 200) {
          } else {
            toast(this, res.message, "error");
          }
        });
        this.test = false;
        this.$router.push("/personalCenter");
      } else {
        toast(this, "请进行电子签名", "error");
      }
    },
    toAccount(){
      this.$router.push("/account");
    },
    openPersional() {
      //跳转个人信息
      this.$router.push("/personalInfo");
    },
  },
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';

.van-icon__image {
  vertical-align: baseline;
}
  .account-item {
    display: flex;
    height: 50px;
    border-bottom: 1px solid #e6e6ee;
    background: rgba(255, 255, 255, 1);

    .item-arrow, .item-icon {
      flex: 1;
      color: #999;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 20px;
      }
    }

    .item-content {
      flex: 6;

      .title {
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: rgba(53, 53, 53, 1);
      }

      .hint {
        font-size: 12px;
        color: rgba(172, 172, 183, 1);
      }
    }
  }
</style>